import type { Adventure } from '../../types'

// Big Small Tall Short - Age 3-4 - Measurement and comparison
export const tillyMeasureCorrect = [
  "Perfect! You can compare sizes!",
  "That's right! You know big and small!",
  "Excellent comparing skills!",
  "Wonderful! Tall or short, you know it!",
  "Yes! That's the correct size!",
  "Brilliant! You're a measurement expert!",
  "Super job! You see the difference!",
  "You got it! Size comparison mastered!",
  "Fantastic! You understand measurement!",
  "Amazing! Big, small, tall, short - you know them all!"
]

export const tillyMeasureWrong = [
  "Look carefully! Is it big or small?",
  "Almost! Compare the sizes!",
  "Good try! Which one is taller?",
  "So close! Look at the difference!",
  "Compare them side by side!",
  "You're learning! Look at the heights!",
  "Try again! Find the biggest one!",
  "Think about it - big or small?",
  "Let's compare together!",
  "Keep trying! Size is fun!"
]

export const bigSmallAdventure: Adventure = {
  id: 'big-small',
  title: 'Big Small Tall Short',
  theme: 'shapes',
  targetAge: '3',
  difficulty: 'easy',
  estimatedDuration: 8,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello size explorer! I am Tilly! Today we are comparing things! Big, small, tall, short - let's discover sizes!",
      duration: 4
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look at the elephant and the mouse! The elephant is BIG! The mouse is small! Can you find big things?",
      duration: 5
    },
    choice1: [
      {
        id: 'animals',
        label: 'Compare animals!',
        tillyLine: "Animals come in all sizes!",
        nextState: 'quiz-1'
      },
      {
        id: 'plants',
        label: 'Compare plants!',
        tillyLine: "Plants grow big or stay small!",
        nextState: 'story-2'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'tap-correct',
      question: 'Which animal is BIG?',
      tillyPrompt: '🐘 🐭 🐇 Who is biggest?',
      options: [
        { id: 'elephant', label: '🐘 Elephant', isCorrect: true },
        { id: 'mouse', label: '🐭 Mouse', isCorrect: false },
        { id: 'rabbit', label: '🐇 Rabbit', isCorrect: false }
      ]
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Great! Now let's look up! The giraffe is TALL! The puppy is short! Can you spot tall things?",
      duration: 4
    },
    choice2: [
      {
        id: 'tall',
        label: 'Find tall things!',
        tillyLine: "Reach for the sky!",
        nextState: 'quiz-2'
      },
      {
        id: 'short',
        label: 'Find short things!',
        tillyLine: "Low to the ground!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'tap-correct',
      question: 'Which one is TALL?',
      tillyPrompt: '🦒 🐶 🐱 Who is tallest?',
      options: [
        { id: 'giraffe', label: '🦒 Giraffe', isCorrect: true },
        { id: 'dog', label: '🐶 Dog', isCorrect: false },
        { id: 'cat', label: '🐱 Cat', isCorrect: false }
      ]
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "Size master! Challenge Round: Compare big, small, tall, short, and even long vs short!",
        duration: 4
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'tap-correct',
          question: 'Which is SMALL?',
          tillyPrompt: '🐋 🐠 🦈 Who is smallest?',
          options: [
            { id: 'whale', label: '🐋 Whale', isCorrect: false },
            { id: 'fish', label: '🐠 Fish', isCorrect: true },
            { id: 'shark', label: '🦈 Shark', isCorrect: false }
          ]
        } as any,
        {
          id: 'challenge-2',
          type: 'tap-correct',
          question: 'Which snake is LONG?',
          tillyPrompt: '🐍 🪱 🐛 Who is longest?',
          options: [
            { id: 'snake', label: '🐍 Snake', isCorrect: true },
            { id: 'worm', label: '🪱 Worm', isCorrect: false },
            { id: 'caterpillar', label: '🐛 Caterpillar', isCorrect: false }
          ]
        } as any,
        {
          id: 'challenge-3',
          type: 'tap-correct',
          question: 'Find the SHORT tree!',
          tillyPrompt: '🌲 🌳 🎄 Which is shortest?',
          options: [
            { id: 'pine', label: '🌲 Pine', isCorrect: false },
            { id: 'tree', label: '🌳 Tree', isCorrect: false },
            { id: 'christmas', label: '🎄 Xmas', isCorrect: true }
          ]
        } as any
      ]
    },
    reward: {
      tillyLine: "Fantastic! You mastered big, small, tall, and short! You're a Measurement Champion!",
      badgeName: 'Size Expert',
      badgeIcon: '📏',
      nextPreview: 'Next time, we will skip count by 2s!'
    }
  }
}
